document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.add('quick-add-ready');

  const modalOverlay = document.getElementById('SmartQuickAddModal');
  const closeButton = document.getElementById('SmartModalClose');
  const addButton = document.getElementById('SmartModalAddBtn');
  const variantsContainer = document.getElementById('SmartModalVariants');
  const i18nElement = document.getElementById('SmartQuickAddI18n');

  let strings = {
    add_to_cart: 'Add to bag',
    sold_out: 'Sold out',
    loading_sizes: 'Loading sizes…',
    loading: 'Loading…',
    sizes_load_error: 'Could not load sizes.',
    select_size: 'Select size:',
    color: 'Color',
    number_locale: 'en',
    currency_code: 'USD'
  };

  if (i18nElement) {
    try {
      strings = { ...strings, ...JSON.parse(i18nElement.textContent) };
    } catch (e) {
      console.error('SmartQuickAdd: invalid i18n JSON', e);
    }
  }

  if (!modalOverlay || !variantsContainer || !addButton) return;

  let currentProductData = null;
  let currentVariantId = null;

  const namedColorHexMap = {
    red: '#FF4136',
    black: '#000000',
    blue: '#0074D9',
    gold: '#A69246',
    green: '#2ECC40',
    yellow: '#FFDC00',
    nude: '#E5C9B3',
    pink: '#FF851B',
    white: '#FFFFFF',
    gray: '#AAAAAA',
    purple: '#B10DC9',
    orange: '#FF851B',
    wine: '#85144b'
  };

  const openModal = () => {
    modalOverlay.setAttribute('open', '');
    document.body.classList.add('overflow-hidden');
  };

  const closeModal = () => {
    modalOverlay.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
  };

  closeButton?.addEventListener('click', closeModal);
  modalOverlay.addEventListener('click', (event) => {
    if (event.target === modalOverlay) closeModal();
  });

  function normalizeImageUrl(raw) {
    if (raw == null || raw === '') return '';
    const s = String(raw).trim();
    if (!s) return '';
    return s.startsWith('//') ? `https:${s}` : s;
  }

  function resolveQuickAddImageUrlFromProduct(product) {
    if (!product) return '';

    const list = product.images;
    if (Array.isArray(list)) {
      for (let i = 0; i < list.length; i += 1) {
        const entry = list[i];
        const candidate =
          typeof entry === 'string'
            ? entry
            : entry && (entry.src || entry.url);
        const absolute = normalizeImageUrl(candidate);
        if (absolute) return absolute;
      }
    }

    if (typeof product.featured_image === 'string') {
      const u = normalizeImageUrl(product.featured_image);
      if (u) return u;
    } else if (product.featured_image && typeof product.featured_image === 'object') {
      const u = normalizeImageUrl(product.featured_image.src || product.featured_image.url);
      if (u) return u;
    }

    if (Array.isArray(product.media)) {
      const imageMedia = product.media.find((m) => {
        const t = String(m?.media_type || '').toLowerCase();
        return t === 'image';
      });
      if (imageMedia) {
        const u = normalizeImageUrl(
          imageMedia.src ||
            (imageMedia.preview_image && imageMedia.preview_image.src) ||
            (imageMedia.sources && imageMedia.sources[0] && imageMedia.sources[0].url)
        );
        if (u) return u;
      }
    }

    return '';
  }

  function resolveQuickAddImageUrlFromCard(card) {
    if (!card) return '';
    const mediaRoot = card.querySelector('.card__media');
    if (!mediaRoot) return '';

    const imgs = mediaRoot.querySelectorAll('img');
    for (let i = 0; i < imgs.length; i += 1) {
      const img = imgs[i];
      if (img.closest('.mobile-card-video')) continue;
      const src = img.currentSrc || img.src;
      if (src && !String(src).includes('square.svg')) {
        return normalizeImageUrl(src);
      }
    }

    const videos = mediaRoot.querySelectorAll('video[poster]');
    for (let j = 0; j < videos.length; j += 1) {
      const vid = videos[j];
      if (vid.closest('.mobile-card-video')) continue;
      const poster = vid.getAttribute('poster');
      const u = normalizeImageUrl(poster);
      if (u) return u;
    }

    return '';
  }

  function applyQuickAddModalImages(product, cardEl) {
    const url =
      resolveQuickAddImageUrlFromProduct(product) || resolveQuickAddImageUrlFromCard(cardEl);
    if (!url) return;
    const desktopImage = document.getElementById('SmartModalImage');
    const mobileImage = document.getElementById('SmartModalImageMobile');
    if (desktopImage) desktopImage.src = url;
    if (mobileImage) mobileImage.src = url;
  }

  function clearVariantsRevealState() {
    variantsContainer.classList.remove(
      'smart-modal-variants--reveal-prep',
      'smart-modal-variants--reveal-on',
      'smart-modal-variants--loading'
    );
  }

  function setVariantsLoading() {
    clearVariantsRevealState();
    variantsContainer.innerHTML = '';
    variantsContainer.classList.add('smart-modal-variants--loading');
    variantsContainer.setAttribute('aria-busy', 'true');

    const skeleton = document.createElement('div');
    skeleton.className = 'smart-modal-variants-skeleton';
    skeleton.setAttribute('aria-hidden', 'true');

    const label = document.createElement('div');
    label.className = 'smart-modal-variants-skeleton__label';

    const sizes = document.createElement('div');
    sizes.className = 'smart-modal-variants-skeleton__sizes';
    for (let i = 0; i < 8; i += 1) {
      sizes.appendChild(document.createElement('span'));
    }

    skeleton.appendChild(label);
    skeleton.appendChild(sizes);

    const sr = document.createElement('p');
    sr.className = 'smart-quick-add__status smart-quick-add__status--loading visually-hidden';
    sr.textContent = strings.loading_sizes;

    variantsContainer.appendChild(skeleton);
    variantsContainer.appendChild(sr);
  }

  function setVariantsError() {
    clearVariantsRevealState();
    variantsContainer.removeAttribute('aria-busy');
    variantsContainer.innerHTML = '';
    const message = document.createElement('p');
    message.className = 'smart-quick-add__status smart-quick-add__status--error';
    message.textContent = strings.sizes_load_error;
    variantsContainer.appendChild(message);
  }

  function requestRevealVariants() {
    clearVariantsRevealState();
    variantsContainer.removeAttribute('aria-busy');
    variantsContainer.classList.add('smart-modal-variants--reveal-prep');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        variantsContainer.classList.add('smart-modal-variants--reveal-on');
      });
    });
  }

  document.addEventListener(
    'click',
    async (event) => {
      const quickAddButton = event.target.closest('.quick-add__submit');
      if (!quickAddButton) return;

      const productUrl = quickAddButton.getAttribute('data-product-url');
      if (!productUrl) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const colorName = (quickAddButton.getAttribute('data-product-color') || '').trim();
      const colorHex = (quickAddButton.getAttribute('data-product-color-hex') || '').trim();

      const baseUrl = productUrl.split('?')[0];
      const card = quickAddButton.closest('.card-wrapper, .product-card-wrapper');
      const prefetchImageUrl = resolveQuickAddImageUrlFromCard(card);
      if (prefetchImageUrl) {
        const desktopImage = document.getElementById('SmartModalImage');
        const mobileImage = document.getElementById('SmartModalImageMobile');
        if (desktopImage) desktopImage.src = prefetchImageUrl;
        if (mobileImage) mobileImage.src = prefetchImageUrl;
      }

      const cardTitle = card?.querySelector('.card__heading');
      const cardPrice = card?.querySelector('.price');

      const titleElement = document.getElementById('SmartModalTitle');
      const priceElement = document.getElementById('SmartModalPrice');
      if (cardTitle && titleElement) titleElement.textContent = cardTitle.textContent.trim();
      if (cardPrice && priceElement) priceElement.innerHTML = cardPrice.innerHTML;

      setVariantsLoading();
      const buttonLabel = addButton.querySelector('.btn-text');
      if (buttonLabel) buttonLabel.textContent = strings.loading;
      addButton.setAttribute('disabled', 'disabled');

      openModal();

      try {
        const response = await fetch(`${baseUrl}.js`);
        currentProductData = await response.json();
        applyQuickAddModalImages(currentProductData, card);
        renderVariants(currentProductData, colorName, colorHex);
      } catch (err) {
        console.error('SmartQuickAdd: failed to fetch product', err);
        setVariantsError();
      }
    },
    true
  );

  function colorSwatchBackground(name, hex) {
    const hexValue = (hex || '').trim();
    if (hexValue) {
      if (hexValue.startsWith('#')) return hexValue;
      if (/^[0-9A-Fa-f]{3,8}$/i.test(hexValue)) return `#${hexValue}`;
      return hexValue;
    }
    const colorKey = (name || '').trim().toLowerCase();
    if (colorKey) return namedColorHexMap[colorKey] || colorKey.replace(/\s+/g, '') || '#cccccc';
    return '#cccccc';
  }

  function hexToRgbChannels(cssColor) {
    const color = (cssColor || '').trim();
    if (!color) return null;
    if (color.startsWith('rgb')) {
      const rgbMatch = color.match(/\d+/g);
      if (rgbMatch && rgbMatch.length >= 3) return [Number(rgbMatch[0]), Number(rgbMatch[1]), Number(rgbMatch[2])];
      return null;
    }
    let hexDigits = color.startsWith('#') ? color.slice(1) : color;
    if (/^[0-9A-Fa-f]{3}$/i.test(hexDigits)) {
      hexDigits = hexDigits[0] + hexDigits[0] + hexDigits[1] + hexDigits[1] + hexDigits[2] + hexDigits[2];
    }
    if (!/^[0-9A-Fa-f]{6}$/i.test(hexDigits)) return null;
    return [parseInt(hexDigits.slice(0, 2), 16), parseInt(hexDigits.slice(2, 4), 16), parseInt(hexDigits.slice(4, 6), 16)];
  }

  function contrastTextForBackground(cssColor) {
    const rgb = hexToRgbChannels(cssColor);
    if (!rgb) return '#ffffff';
    const luminance = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
    return luminance > 0.55 ? '#111111' : '#ffffff';
  }

  function sizeButtonDisplayText(raw) {
    const trimmed = String(raw || '').trim();
    const base = trimmed.includes('/') ? trimmed.split('/').pop().trim() : trimmed;
    const numberMatch = base.match(/(\d+(?:[.,]\d+)?)/);
    if (numberMatch) return numberMatch[1].replace(',', '.');
    return base;
  }

  function renderVariants(product, colorName, colorHex) {
    variantsContainer.innerHTML = '';
    variantsContainer.removeAttribute('aria-busy');
    variantsContainer.classList.remove('smart-modal-variants--loading');

    const name = (colorName || '').trim();
    const hex = (colorHex || '').trim();

    if (name || hex) {
      const group = document.createElement('div');
      group.className = 'smart-variant-group color-group';

      const header = document.createElement('div');
      header.className = 'smart-modal-color-header';

      const label = document.createElement('span');
      label.className = 'form__label';
      label.textContent = name ? `${strings.color} — ${name.toUpperCase()}` : strings.color;
      header.appendChild(label);

      const backgroundColor = colorSwatchBackground(name, hex);

      if (hex) {
        const colorDisc = document.createElement('div');
        colorDisc.className = 'smart-modal-color-hex-disc';
        colorDisc.style.backgroundColor = backgroundColor;
        const foregroundColor = contrastTextForBackground(backgroundColor);
        colorDisc.style.color = foregroundColor;
        colorDisc.style.textShadow =
          foregroundColor === '#ffffff' ? '0 1px 2px rgba(0,0,0,0.45)' : '0 1px 0 rgba(255,255,255,0.65)';
        const hexSpan = document.createElement('span');
        colorDisc.appendChild(hexSpan);
        header.appendChild(colorDisc);
      }

      group.appendChild(header);

      if (!hex && name) {
        const swatchesContainer = document.createElement('div');
        swatchesContainer.className = 'smart-swatches-list';

        const swatch = document.createElement('div');
        swatch.className = 'smart-swatch active';
        swatch.style.cursor = 'default';
        swatch.style.backgroundColor = backgroundColor;

        swatchesContainer.appendChild(swatch);
        group.appendChild(swatchesContainer);
      }

      variantsContainer.appendChild(group);
    }

    if (product.variants.length === 1 && product.variants[0].title === 'Default Title') {
      currentVariantId = product.variants[0].id;
      updateAddButton(product.variants[0]);
      clearVariantsRevealState();
      return;
    }

    product.options.forEach((option, optionIndex) => {
      if (option.name.toLowerCase().includes('color')) return;

      const group = document.createElement('div');
      group.className = 'smart-variant-group size-group';

      const sizeLabel = document.createElement('span');
      sizeLabel.className = 'form__label';
      sizeLabel.textContent = strings.select_size;
      group.appendChild(sizeLabel);

      const sizesContainer = document.createElement('div');
      sizesContainer.className = 'smart-sizes-list';

      option.values.forEach((value, valueIndex) => {
        const sizeButton = document.createElement('button');
        sizeButton.type = 'button';
        sizeButton.className = 'smart-size-text';
        sizeButton.dataset.optionIndex = `option${optionIndex + 1}`;
        sizeButton.dataset.value = value;
        sizeButton.textContent = sizeButtonDisplayText(value);

        if (valueIndex === 0) sizeButton.classList.add('active');

        sizeButton.addEventListener('click', () => {
          Array.from(sizesContainer.children).forEach((child) => child.classList.remove('active'));
          sizeButton.classList.add('active');
          findMatchingVariant();
        });

        sizesContainer.appendChild(sizeButton);
      });

      group.appendChild(sizesContainer);
      variantsContainer.appendChild(group);
    });

    findMatchingVariant();
    requestRevealVariants();
  }

  function findMatchingVariant() {
    if (!currentProductData) return;

    const selectedValues = {};
    document.querySelectorAll('.smart-size-text.active').forEach((button) => {
      selectedValues[button.dataset.optionIndex] = button.dataset.value;
    });

    const matchedVariant = currentProductData.variants.find((variant) => {
      let isMatch = true;
      if (selectedValues.option1 && variant.option1 !== selectedValues.option1) isMatch = false;
      if (selectedValues.option2 && variant.option2 !== selectedValues.option2) isMatch = false;
      if (selectedValues.option3 && variant.option3 !== selectedValues.option3) isMatch = false;
      return isMatch;
    });

    const localeTag = strings.number_locale || 'en';
    const currencyCode = strings.currency_code || 'USD';

    if (matchedVariant) {
      currentVariantId = matchedVariant.id;
      updateAddButton(matchedVariant);

      const priceStr = (matchedVariant.price / 100).toLocaleString(localeTag, {
        style: 'currency',
        currency: currencyCode
      });
      const compareStr = matchedVariant.compare_at_price
        ? (matchedVariant.compare_at_price / 100).toLocaleString(localeTag, {
            style: 'currency',
            currency: currencyCode
          })
        : '';

      const hasDiscount = localStorage.getItem("promo_discount") ? JSON.parse(localStorage.getItem("promo_discount")) : null;
      const isOnCollection = window.location.href.includes('view=promo') && window.location.href.includes('/collections');

      const priceHost = document.getElementById('SmartModalPrice');
      if (!priceHost) return;

      if (compareStr && matchedVariant.compare_at_price > matchedVariant.price) {
        priceHost.innerHTML = `
          <div class="price__sale" style="font-size:16px; display: flex; gap: 1rem; align-items: center; justify-content: center;">
            <s class="price-item price-item--regular">${compareStr}</s>
            <span class="price-item price-item--sale">${priceStr}</span>
          </div>
        `;
      } else if(hasDiscount && isOnCollection) {
        const basePrice = matchedVariant?.price ? matchedVariant.price / 100 : 0;
        const discountRaw = parseFloat(hasDiscount?.value) || 0;
        let finalPrice = basePrice;
        if (hasDiscount?.type === 'Percentage') {
          finalPrice = basePrice - (basePrice * discountRaw / 100);
        } else {
          finalPrice = basePrice - discountRaw;
        }

        const discountedPriceStr = finalPrice.toLocaleString(localeTag, {
          style: 'currency',
          currency: currencyCode
        });

        priceHost.innerHTML = `
              <div class="price__sale" style="font-size:16px; display: flex; gap: 1rem; align-items: center; justify-content: center;">
                <s class="price-item price-item--regular">${priceStr}</s>
                <span class="price-item price-item--sale">${discountedPriceStr}</span>
              </div>
            `;
      } else {
        priceHost.innerHTML = `
          <div class="price__regular">
            <span class="price-item price-item--regular">${priceStr}</span>
          </div>
        `;
      }
    }

    const sizeButtons = document.querySelectorAll('.size-group .smart-size-text');
    if (sizeButtons.length > 0) {
      const sizeOptionIndex = sizeButtons[0].dataset.optionIndex;
      sizeButtons.forEach((button) => {
        const sizeValue = button.dataset.value;
        const isAvailable = currentProductData.variants.some(
          (variant) => variant[sizeOptionIndex] === sizeValue && variant.available
        );
        button.classList.toggle('sold-out', !isAvailable);
      });
    }
  }

  function updateAddButton(variant) {
    const buttonLabel = addButton.querySelector('.btn-text');
    if (variant.available) {
      addButton.removeAttribute('disabled');
      if (buttonLabel) buttonLabel.textContent = strings.add_to_cart;
    } else {
      addButton.setAttribute('disabled', 'disabled');
      if (buttonLabel) buttonLabel.textContent = strings.sold_out;
    }
  }

  addButton?.addEventListener('click', async () => {
    if (!currentVariantId) return;

    addButton.classList.add('loading');
    addButton.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');
    addButton.setAttribute('disabled', 'disabled');

    try {
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      let bodyData = { id: currentVariantId, quantity: 1 };

      if (cart && typeof cart.getSectionsToRender === 'function') {
        bodyData.sections = cart.getSectionsToRender().map((section) => section.id);
        bodyData.sections_url = window.location.pathname;
      }

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(bodyData)
      });

      const parsedState = await response.json();

      if (response.ok) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'smart-quick-add',
            productVariantId: String(currentVariantId),
            cartData: parsedState,
          });
        }
        closeModal();
        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(parsedState);
        } else {
          document.documentElement.dispatchEvent(new CustomEvent('cart:build'));
          if (window.quickShopManager) {
            window.quickShopManager.forceCartUpdate();
            window.quickShopManager.openCartDrawer();
          }
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      addButton.classList.remove('loading');
      addButton.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
      addButton.removeAttribute('disabled');
    }
  });
});
